import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { BaseComponent } from '../../../components/BaseComponent';
import { SearchSelect } from '../../../components/SearchSelectComponent';
import { changeProductFilter } from '../actions';

const Container = styled.div``;

const STATE = {};
/* eslint-disable react/prefer-stateless-function */
class ProductSearchTypeComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE }, this.doSearch);
  }

  get options() {
    return [{ label: this.lbl(`invoice.subject.type.all`), value: null }].concat(
      ['isCounter', 'isOneTime'].map(value => ({
        label: this.lbl(`product.column.type.${value}`),
        value,
      })),
    );
  }

  get value() {
    return this.options.find(o => o.value == this.props.filter.type);
  }

  render() {
    return (
      <Container>
        <SearchSelect
          options={this.options}
          value={this.value}
          onChange={pair =>
            this.props.setValue('type', {
              [pair.value]: 1,
            })
          }
        />
      </Container>
    );
  }
}

ProductSearchTypeComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setValue(type, string) {
      dispatch(changeProductFilter(type, string));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const ProductSearchType = compose(withConnect, withRouter, injectIntl)(ProductSearchTypeComp);
